import React from 'react';
import { useAuth } from '../../context/AuthContext';

const SecurityTab = () => {
  const { user } = useAuth();

  return (
    <div className="settings-section">
      <h2>Security</h2>
      <p className="description">Manage your account security settings</p>

      <div className="settings-section">
        <h3>Password</h3>
        <p style={{ color: '#6b7280', marginBottom: '16px' }}>
          Password management is handled through Supabase Auth.
        </p>
        <button className="btn-secondary" disabled>
          Change Password
        </button>
      </div>

      <div className="settings-section">
        <h3>Two-Factor Authentication</h3>
        <p style={{ color: '#6b7280', marginBottom: '16px' }}>
          Add an extra layer of security to your account.
        </p>
        <button className="btn-secondary" disabled>
          Enable 2FA
        </button>
      </div>

      <div className="settings-section">
        <h3>Active Sessions</h3>
        <p style={{ color: '#6b7280', marginBottom: '16px' }}>
          View and manage your active sessions across devices.
        </p>
        <div style={{ padding: '16px', background: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontWeight: '600', color: '#111827' }}>Current Session</div>
              <div style={{ fontSize: '0.8125rem', color: '#6b7280' }}>
                {user?.email} • Current browser
              </div>
            </div>
            <span style={{ fontSize: '0.75rem', color: '#059669', fontWeight: '600' }}>Active</span>
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3>Danger Zone</h3>
        <p style={{ color: '#6b7280', marginBottom: '16px' }}>
          Permanently delete your account and all associated data.
        </p>
        <button className="btn-danger" disabled>
          Delete Account
        </button>
        <p style={{ fontSize: '0.75rem', color: '#9ca3af', marginTop: '8px' }}>
          Contact support to delete your account
        </p>
      </div>
    </div>
  );
};

export default SecurityTab;
